import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import loader from "../../../assets/images/loader.gif";
import Pagination from "../../../components/common/Pagination";
import ListAction from "../../../components/dashboard/admin-dashboard/ListAction";
import UserDetailModal from "../../../components/dashboard/admin-dashboard/detail-modal/UserDetailModal";
import AlertModal from "../../../components/dashboard/common/AlertModal";
import TopHeader from "../../../components/dashboard/user-dashboard/TopHeader";
import {
  funScamStatus,
  getAllScamReports,
} from "../../../service/DashboardService";
import { getProfessionalById } from "../../../service/MainService";
import { AppContext } from "../../../context/AppContext";
import { useContext } from "react";

export default function ScamReport() {
  const [openAlert, setOpenAlert] = useState(false);
  const [scamStatus, setScamStatus] = useState({});
  const { scamStore, setScamStore } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalScamCount, setTotalScamCount] = useState(0);
  const topRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [userDetail, setUserDetail] = useState({});
  const userIdString = localStorage.getItem("userId");
  const userId = parseInt(userIdString);

  useEffect(() => {
    fetchData();
    scrollToTop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("accessToken");
      const response = await getAllScamReports(token, currentPage, 10);
      setScamStore(response.Result);
      setTotalScamCount(response.TotalScamReports);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const scamApproval = (reportId) => {
    setScamStatus({
      ReporterId: reportId,
      Status: "SCAM",
      user: { UserId: userId },
    });
    setOpenAlert(true);
  };
  const scamReject = (reportId) => {
    setScamStatus({
      ReporterId: reportId,
      Status: "DECLINE",
      user: { UserId: userId },
    });
    setOpenAlert(true);
  };

  const scamStatusUpdate = async () => {
    try {
      const response = await funScamStatus(scamStatus);
      console.log(response);
      if (response.header.code === 600) {
        toast.success(response.body.value);
        const updatedpendingProjects = scamStore.filter(
          (item) => item.ReportId !== scamStatus.ReportId
        );
        setScamStore(updatedpendingProjects);
      } else {
        toast.error(response.body.value);
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
    setOpenAlert(false);
  };

  const handlePageChange = (page, e) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  const scrollToTop = () => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const formatDateTime = (dateTimeString) => {
    const options = {
      month: "short",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };
    const dateTime = new Date(dateTimeString);
    return dateTime.toLocaleDateString("en-US", options);
  };

  const handleViewClick = async (userId) => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await getProfessionalById(userId, token);
      setUserDetail(response);
      setOpen(true);
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  return (
    <>
      <div ref={topRef} />
      <TopHeader />
      {loading ? (
        <div className="flex justify-center ">
          <img src={loader} alt="Loading" />
        </div>
      ) : (
        <div>
          <div className="flex items-center justify-between gap-x-6 px-5 py-5 bg-white p-2 mb-2 rounded-md">
            <h1 className="text-center flex-1">Reported by</h1>
            <h1 className="text-center flex-1">Reported account</h1>
            <h1 className="text-center flex-1">Message</h1>
            <h1 className="text-center flex-1">Mark As</h1>
          </div>
          {scamStore.length === 0 ? (
            <p colSpan="4" className="text-center py-4">
              No records found
            </p>
          ) : (
            scamStore.map((scam, index) => (
              <ul key={index} className="divide-y divide-gray-100">
                <li className="flex items-center justify-between gap-x-6 px-5 py-5 bg-white p-2 border-b border-gray-600 rounded-md">
                  <p className="mt-1 truncate text-sm leading-5 text-gray-700 text-center flex-1">
                    {scam.user.UserName}
                  </p>
                  <p className="mt-1 truncate text-sm leading-5 text-gray-700 text-center flex-1">
                    {scam.ReporterName}
                  </p>
                  <button
                    type="button"
                    className="py-2.5 px-5 me-2 mb-2 text-sm font-medium text-red-800 focus:outline-none bg-white rounded-full border border-gray-200 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 cursor-pointer flex-1"
                    style={{ maxWidth: "600px" }}
                  >
                    {scam.Message}
                  </button>
                  <div className="flex flex-col items-center justify-center">
                    <p className="text-sm leading-6 text-gray-900 text-center">
                      {formatDateTime(scam.UploadDateTime)}
                    </p>
                    <div className="flex items-center gap-4 mt-2 justify-center">
                      <span
                        className="text-red-600 cursor-pointer"
                        onClick={() => scamApproval(scam.ReporterId)}
                      >
                        Scam
                      </span>
                      <span
                        className="bg-blue-500 text-white text-xs font-bold me-2 px-2.5 py-1.5 rounded-full dark:bg-green-900 dark:text-green-300 cursor-pointer"
                        onClick={() => scamReject(scam.ReporterId)}
                      >
                        Declined
                      </span>
                      <ListAction
                        onViewClick={() => handleViewClick(scam.user.UserId)}
                        showDeleteButton={false}
                      />
                    </div>
                  </div>
                </li>
              </ul>
            ))
          )}

          {totalScamCount > 10 && (
            <Pagination
              currentPage={currentPage}
              totalItems={totalScamCount}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      )}
      <AlertModal
        open={openAlert}
        setOpen={setOpenAlert}
        statusUpdate={scamStatusUpdate}
      />
      <UserDetailModal open={open} setOpen={setOpen} userDetail={userDetail} />
    </>
  );
}
